import { environment } from '@/assets/environment';
import { RequestEssenceType } from '@/models/entities/request-essence.model';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { ICommonEssence } from '@/models/store/common-essences/common-essence.model';
import { IEssencesState } from '@/models/store/common-essences/common-essences-state.model';
import { isEqual } from 'lodash';
import { Module } from 'vuex';

const commonEssencesModule: Module<IEssencesState, unknown> = {
    state: {
        bonuses: [],
        guaranties: [],
        delivery: [],
    },

    actions: {
        fetchEssences: async ({ commit }, payload: { type: RequestEssenceType }) => {
            const params = new URLSearchParams();
            params.append('type', `${payload.type}`);

            const response = await fetch(`${environment.baseUrl}/api/common-describe?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const essences = (await response.json()).essences;
            if (isEqual(payload.type, 'delivery')) commit('setDelivery', essences);
            if (isEqual(payload.type, 'bonuses')) commit('setBonuses', essences);
            if (isEqual(payload.type, 'guarantee')) commit('setGuaranties', essences);
        },
    },

    mutations: {
        setBonuses: (store, payload: ICommonEssence[]) => {
            store.bonuses = [...payload];
        },

        setGuaranties: (store, payload: ICommonEssence[]) => {
            store.guaranties = [...payload];
        },

        setDelivery: (store, payload: ICommonEssence[]) => {
            store.delivery = [...payload];
        },
    },

    getters: {
        getBonuses: (store) => store.bonuses,
        getDelivery: (store) => store.delivery,
        getGuaranties: (store) => store.guaranties,
    },
};

export default commonEssencesModule;
